import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ItemVisual } from '../components/ItemVisual';
import { Piko } from '../components/Piko';
import { audio } from '../core/audio';
import { useActivity } from './useActivity';

export function PikoBag({ activity, onComplete }) {
  const [phase, setPhase] = useState('show');
  const { state, answer, showHint } = useActivity(activity, onComplete);
  const choices = useState(() => [...activity.inside, ...(activity.distractors || [activity.distractor])].sort(() => Math.random() - 0.5))[0];
  const target = activity.inside[0];

  useEffect(() => {
    let alive = true;
    (async () => {
      await audio.playVoice('mem_look');
      await new Promise((r) => setTimeout(r, 3000));
      if (!alive) return;
      setPhase('ask');
      audio.playVoice(activity.voice);
    })();
    return () => { alive = false; };
  }, [activity.id]); // eslint-disable-line

  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-8 px-5" data-testid={`activity-${activity.id}`}>
      <div className="flex items-end gap-4">
        <Piko pose="think" size={110} float={false} />
        <svg width="110" height="110" viewBox="0 0 100 100">
          <path d="M20 40 Q50 25 80 40 L75 90 Q50 98 25 90 Z" fill="#E2A15A" />
          <path d="M30 40 Q50 12 70 40" fill="none" stroke="#B87B3D" strokeWidth="6" strokeLinecap="round" />
        </svg>
      </div>
      {phase === 'show' && (
        <div className="flex gap-6">
          {activity.inside.map((it, i) => (
            <motion.div key={it.id} initial={{ y: 0, opacity: 1 }}
              animate={{ y: [-10, -40, 30], opacity: [1, 1, 0], scale: [1, 1, 0.5] }}
              transition={{ duration: 1.6, delay: 0.8 + i * 0.9 }}
              className="rounded-[1.8rem] p-2 bg-white/85" style={{ border: '4px solid #fff' }}>
              <ItemVisual item={it} size={90} />
            </motion.div>
          ))}
        </div>
      )}
      {phase === 'ask' && (
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="flex gap-4 flex-wrap justify-center">
          {choices.map((it) => {
            const isCorrect = it.id === target.id;
            return (
              <motion.button key={it.id} data-testid={`choice-${it.id}`} whileTap={{ scale: 0.92 }}
                animate={state === 'correct' && isCorrect ? { scale: [1, 1.15, 1.08] } : showHint && isCorrect ? { scale: [1, 1.06, 1] } : {}}
                transition={showHint && isCorrect ? { repeat: Infinity, duration: 1.2 } : {}}
                onClick={() => answer(isCorrect)}
                className="rounded-[2rem] p-3 bg-white/85 backdrop-blur min-w-[96px] min-h-[96px]"
                style={{ border: '5px solid #fff', boxShadow: state === 'correct' && isCorrect ? '0 0 0 6px #FFD166' : '0 10px 24px rgba(29,53,87,0.15)' }}>
                <ItemVisual item={it} size={88} />
              </motion.button>
            );
          })}
        </motion.div>
      )}
    </div>
  );
}
